import {
    PractitionerActionTypes,
    ADD_PRACTITIONER_LANGUAGE,
    ADD_PRACTITIONER_SPECIALIZATION,
    GET_PRACTITIONER_DATA_REQUEST,
    GET_PRACTITIONER_DATA_SUCCESS,
    GET_USER_DATA_REQUEST,
    GET_USER_DATA_SUCCESS,
    REMOVE_PRACTITIONER_LANGUAGE,
    REMOVE_PRACTITIONER_SPECIALIZATION,
    SET_PAYMENT_DETAILS_UPDATES,
    SET_PRACTITIONER_LANGUAGES,
    SET_PRACTITIONER_SPECIALIZATIONS,
    UserActionTypes,
} from './types';
import { AppThunk } from 'src/pods/system/state/types';

import UserApiCalls from '../api/ApiCalls';
import { IUserResponseDTO } from '../api/ResponseDtos';
import { toggleErrorModal } from 'src/pods/system/state/actions';

import { translate } from '../../../translations/translations';
import { parseError } from '../../../utils/helpers';
import PractitionerModel from 'src/pods/user/models/PractitionerModel';
import LanguageModel from '../models/LanguageModel';
import PractitionerSpecializationModel from '../models/PractitionerSpecializationModel';

export function getUserDataRequest(): UserActionTypes {
    return {
        type: GET_USER_DATA_REQUEST,
    };
}

export function getUserDataSuccess(user: IUserResponseDTO): UserActionTypes {
    return {
        type: GET_USER_DATA_SUCCESS,
        payload: user,
    };
}

export function getPractitionerRequest(): PractitionerActionTypes {
    return {
        type: GET_PRACTITIONER_DATA_REQUEST,
    };
}

export function getPractitionerSuccess(practitioner: PractitionerModel): PractitionerActionTypes {
    return {
        type: GET_PRACTITIONER_DATA_SUCCESS,
        payload: practitioner,
    };
}

export function setSettingsUpdated(update: boolean): PractitionerActionTypes {
    return {
        type: SET_PAYMENT_DETAILS_UPDATES,
        payload: update,
    };
}

export function setPractitionerLanguages(languages: LanguageModel[]): PractitionerActionTypes {
    return {
        type: SET_PRACTITIONER_LANGUAGES,
        payload: languages,
    };
}

export function addPractitionerLanguage(language: LanguageModel): PractitionerActionTypes {
    return {
        type: ADD_PRACTITIONER_LANGUAGE,
        payload: language,
    };
}

export function removePractitionerLanguage(languageId: number): PractitionerActionTypes {
    return {
        type: REMOVE_PRACTITIONER_LANGUAGE,
        payload: languageId,
    };
}

export function setPractitionerSpecializations(
    specializations: PractitionerSpecializationModel[],
): PractitionerActionTypes {
    return {
        type: SET_PRACTITIONER_SPECIALIZATIONS,
        payload: specializations,
    };
}

export function addPractitionerSpecialization(
    specialization: PractitionerSpecializationModel,
): PractitionerActionTypes {
    return {
        type: ADD_PRACTITIONER_SPECIALIZATION,
        payload: specialization,
    };
}

export function removePractitionerSpecialization(specializationId: number): PractitionerActionTypes {
    return {
        type: REMOVE_PRACTITIONER_SPECIALIZATION,
        payload: specializationId,
    };
}

export function getUser(): AppThunk {
    return async (dispatch) => {
        try {
            dispatch(getUserDataRequest());
            const { data } = await UserApiCalls.getUser();
            dispatch(getUserDataSuccess(data));
        } catch (err) {
            const errorMessage = parseError(err, 'Error occurred on getting user.');
            dispatch(toggleErrorModal(translate('errors.GENERAL_ERROR_TITLE'), errorMessage));
        }
    };
}

export function getPractitioner(): AppThunk {
    return async (dispatch) => {
        try {
            dispatch(getPractitionerRequest());
            const { data } = await UserApiCalls.getPractitioner();
            dispatch(getPractitionerSuccess(data));
            dispatch(setPractitionerLanguages(data.languages ?? []));
            dispatch(setPractitionerSpecializations(data.specializations ?? []));
        } catch (err) {
            const errorMessage = parseError(err, 'Error occurred on getting practitioner.');
            console.log(errorMessage);
        }
    };
}
